import { not, isEmpty } from 'ramda';
import { useEffect, useRef } from 'react';
import type React from 'react';
import AnimateHeight from 'react-animate-height';
import ListItemHeader from './ListItemHeader';

type OwnProps = React.PropsWithChildren<{
  className?: string;
  dataQa: string;
  facetContent: any; // TODO: Can we figure out another way of doing this? Alternatively, we improve the type definition.
  facetName: string;
  onToggle: () => void;
  expandOnOpen?: boolean;
  scrollIntoView?: boolean;
  show: boolean;
}>;

const FilterDrawer = ({
  children,
  className,
  dataQa,
  facetContent,
  facetName,
  onToggle,
  expandOnOpen,
  scrollIntoView,
  show
}: OwnProps) => {
  const drawerRef = useRef<HTMLDivElement>(null);
  const headerRef = useRef<HTMLDivElement>(null);
  const hasContent = not(isEmpty(facetContent));

  const handleScrollIntoView = () => {
    if (show && scrollIntoView) {
      drawerRef.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest'
      });
    }
  };

  const handleCloseScroll = () => {
    if (
      headerRef.current == null ||
      headerRef.current.offsetParent == null ||
      drawerRef.current == null
    ) {
      return;
    }

    const isDrawerInView =
      headerRef.current.offsetParent.scrollHeight -
        headerRef.current.offsetParent.getBoundingClientRect().height <
      drawerRef.current.offsetHeight - headerRef.current.offsetHeight;

    if (!isDrawerInView && !show && scrollIntoView) {
      headerRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'end'
      });
    }
  };

  useEffect(() => {
    if (expandOnOpen) {
      drawerRef.current?.scrollIntoView({
        block: 'start'
      });
    }
  }, [expandOnOpen]);

  return (
    <div ref={drawerRef}>
      <ListItemHeader
        className={className}
        dataQa={`${dataQa}-header`}
        onToggle={onToggle}
        text={facetName}
        expand={show}
        ref={headerRef}
      />
      {hasContent && (
        <AnimateHeight
          duration={500}
          height={show ? 'auto' : 0}
          data-qa={dataQa}
          onAnimationEnd={handleScrollIntoView}
          onAnimationStart={handleCloseScroll}
        >
          {children}
        </AnimateHeight>
      )}
    </div>
  );
};

export default FilterDrawer;
